// import Error from 'components/alerts/Error';
import { Text } from 'components/common/form/modules/input/Text';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { isEmailAvailable, isUsernameAvailable, updateUser } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import ImageUpload from 'components/upload/ImageUpload';
import React, { useCallback, useState } from 'react'
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import UserDucks from 'stores/ducks/User.duck';

const UserSettingsModal: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const [username, setUsername] = useState(props.user.username)
    const [name, setName] = useState(props.user.name)
    const [email, setEmail] = useState(props.user.email)
    const [lastname, setLastname] = useState(props.user.lastname)
    const [password, setPassword] = useState('')
    // const [confirmPassword, setConfirmPassword] = useState('')

    const [avatar, setAvatar] = useState(props.user.avatar)

    const [btnDisabled, setBtnDisabled] = React.useState(false)
    const [saveBtnText, setSaveBtnText] = React.useState('SAVE')

    const emailIsValid = (e) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
    }

    const resetSaveBtn = () => {
        setBtnDisabled(false)
        setSaveBtnText('SAVE')
    }

    const handleUpdateCampaign = useCallback(() => {

        if (username === '') {
            return alert('Username is required')
        }

        if (username.includes('-')) {
            return alert('Username must not contain -')
        }

        if (name === '') {
            return alert('First Name is required')
        }

        if (lastname === '') {
            return alert('Last Name is required')
        }

        if (email === '') {
            return alert('Email is required')
        }

        if (!emailIsValid(email)) {
            return alert('Email is invalid')
        }

        if (password === '') {
            return alert('Password is required')
        }

        setBtnDisabled(true)
        setSaveBtnText('SAVING...')

        // User update mutation
        // Set new user prop
        // Clear old cookies
        // Set new cookies
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isUsernameAvailable,
                variables: {
                    username: username.toLowerCase()
                }
            })
            .then(res => {
                if (res.data.data.user.isUsernameAvailable || username.toLowerCase().trim() === props.user.username.trim()) {
                    fetchAPI
                        .post(API_ENDPOINTS.BASE_URL, {
                            query: isEmailAvailable,
                            variables: {
                                email: email.toLowerCase()
                            }
                        })
                        .then(res2 => {
                            if (res2.data.data.user.isEmailAvailable || email.toLowerCase().trim() === props.user.email.trim()) {
                                fetchAPI
                                    .post(API_ENDPOINTS.BASE_URL, {
                                        query: updateUser,
                                        variables: {
                                            user: {
                                                email,
                                                name,
                                                lastname,
                                                username: username.toLowerCase(),
                                                password,
                                                avatar
                                            }
                                        }
                                    })
                                    .then(res3 => {
                                        if (res3.data.data.user.update) {
                                            // Change redux state and update cookies
                                            const deepCopyOfUser = JSON.parse(JSON.stringify({
                                                ...props.user,
                                                name,
                                                email,
                                                lastname,
                                                username: username.toLowerCase(),
                                                avatar
                                            }))
                                            const userCookie = props.cookies.get("user");
                                            if (userCookie.token) {
                                                deepCopyOfUser.token = userCookie.token;
                                                props.cookies.remove("user", { path: "/" });
                                                props.cookies.remove("token", { path: "/" });
                                                const date = new Date(); date.setDate(date.getDate() + 7);
                                                props.cookies.set("user", deepCopyOfUser, { path: "/", expires: date });
                                                props.cookies.set("token", deepCopyOfUser.token, { path: "/", expires: date });
                                            }
                                            window.location.reload()
                                        } else {
                                            resetSaveBtn()
                                            return alert('Something went wrong, try again.')
                                        }
                                    })
                                    .catch(err => {
                                        console.log(err)
                                        alert('Something went wrong, try again.')
                                        resetSaveBtn()
                                    })

                            } else {
                                resetSaveBtn()
                                return alert('Email already in use.')
                            }
                        })
                        .catch(err => {
                            console.log(err)
                            alert('Something went wrong, try again.')
                            resetSaveBtn()
                        })
                } else {
                    resetSaveBtn()
                    return alert('Username already in use.')
                }
            })
            .catch(err => {
                console.log(err)
                alert('Something went wrong, try again.')
                resetSaveBtn()
            })
    }, [name, lastname, password, email, props.user, avatar])

    const updateAvatar = useCallback((imgUrl) => {
        setAvatar(imgUrl)
    }, [setAvatar])

    return <div>
        <ImageUpload
            imgSrc={avatar !== null ? avatar : 'https://platform.isotopeticketing.com/landing.png'}
            onUpload={imgUrl => updateAvatar(imgUrl)}
            avatar={true}
        />
        <div style={{ padding: '20px', paddingTop: '30px' }}>
            <div style={{ marginBottom: 4 }}>
                <Text
                    label='Username *'
                    value={username}
                    onChange={e => setUsername((e.target.value).split(' ').join(''))}
                    required={true}
                />
            </div>
            <div style={{ marginBottom: 4 }}>
                <Text
                    label='Email *'
                    value={email}
                    onChange={e => setEmail((e.target.value).split(' ').join(''))}
                    required={true}
                />
            </div>
            <div style={{ marginBottom: 4 }}>
                <Text
                    label='First Name *'
                    value={name}
                    onChange={e => setName(e.target.value)}
                    required={true}
                />
            </div>
            <div style={{ marginBottom: 4 }}>
                <Text
                    label='Last Name *'
                    value={lastname}
                    onChange={e => setLastname(e.target.value)}
                />
            </div>
            <div>
                <Text
                    label='Update Password *'
                    value={password}
                    name='password'
                    onChange={e => setPassword(e.target.value)}
                />
            </div>
            <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                <button
                    disabled={btnDisabled}
                    role="submit"
                    type="submit"
                    className="new-button-save"
                    onClick={e => handleUpdateCampaign()}
                >
                    {saveBtnText}
                </button>
                <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
                    <button className='new-button-cancel' onClick={() => closeModal()}>
                        CANCEL
                    </button>
                </div>
            </div>
        </div>
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

const x = withCookies(UserSettingsModal)
export default connect(mapStateToProps)(x);


// WEBPACK FOOTER //
// ./src/components/common/controls/navbar/UserSettings.tsx